import {isDevMode, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {SharedModule} from "@shared/shared.module";
import {InputTextModule} from 'primeng/inputtext';
import {PasswordModule} from 'primeng/password';

import {ProfileDataComponent} from './components/profile-data/profile-data.component';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {ProfileComponent} from './routes/profile/profile.component';
import {TranslateModule} from "@ngx-translate/core";
import { AccountDataFormComponent } from './components/account-data-form/account-data-form.component';

@NgModule({
  declarations: [
    ProfileDataComponent,
    ChangePasswordComponent,
    ProfileComponent,
    AccountDataFormComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    InputTextModule,
    PasswordModule,
  ],
  exports: [
    ProfileComponent
  ]
})
export class UserProfileModule {
  constructor() {
    if (isDevMode())
      console.log('UserProfileModule');
  }
}
